import React from "react";
import { ContentSection, ensure } from "sprint-common-web";

import { RecordType } from "../../../../../../common/types/RecordType";
import { FileRecordDetails } from "../../../../../common/file-record-details/FileRecordDetails";
import { AudioFileRecordTechnicalSection } from "./audio/AudioFileRecordTechnicalSection";
import { VideoFileRecordTechnicalSection } from "./video/VideoFileRecordTechnicalSection";

interface FileRecordTechnicalSectionProps {
    fileRecordDetails: FileRecordDetails;
    isFileRecordDetailsLoading: boolean;
}

export const FileRecordTechnicalSection = ({
    fileRecordDetails,
    isFileRecordDetailsLoading
}: FileRecordTechnicalSectionProps): JSX.Element => {
    ensure(fileRecordDetails);

    switch (fileRecordDetails.type) {
        case RecordType.Video:
            return (
                <VideoFileRecordTechnicalSection
                    fileRecordDetails={fileRecordDetails}
                    isFileRecordDetailsLoading={isFileRecordDetailsLoading}
                />
            );

        case RecordType.Audio:
            return (
                <AudioFileRecordTechnicalSection
                    fileRecordDetails={fileRecordDetails}
                    isFileRecordDetailsLoading={isFileRecordDetailsLoading}
                />
            );

        case RecordType.Subtitle:
            return <></>;

        default:
            return (
                <ContentSection
                    header="File record technical"
                    isLoading={isFileRecordDetailsLoading}
                    style={{ height: 300 }}
                />
            );
    }
};
